module.exports = __webpack_public_path__ + "static/media/peteMaribeth55.8fb0cb89.png";